import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function buildUrlWithLang(path: string, lang: string): string {
  const url = new URL(path, window.location.origin);
  
  if (lang === 'pt') {
    // PT is default: remove lang param to always link to canonical URLs
    url.searchParams.delete('lang');
  } else {
    // For other languages (EN), add the lang parameter
    url.searchParams.set('lang', lang);
  }
  
  return url.pathname + url.search + url.hash;
}
